import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import { DateFormatMAS90 } from '../../functions/dateFormat';
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { AiOutlineClockCircle, AiOutlineWarning } from 'react-icons/ai';

export default class extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    
    state = {

    }

    selectColor(number) {
        if (number >= 0 && number <= 14) {
            return "status-success"
        } else if (number >= 15 && number <= 29) {
            return "status-warning"
        } else if (number >= 3) {
            return "status-danger"
        }
                
        return ""
    }


    render() {
        // Get request status
        const { loading, error, Title } = this.props;

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <div>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card status-success'>
                                <p className='metric-label'><AiOutlineClockCircle style={{marginRight:4}}/> 0–14 Days</p>

                                {this.props.Totals.TotalR1 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR1 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-success'>{NumberFormat(this.props.Totals.Range1)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR1))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card status-warning'>
                                <p className='metric-label'><AiOutlineClockCircle style={{marginRight:4}}/> 15–29 Days</p>

                                {this.props.Totals.TotalR2 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR2 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-warning'>{NumberFormat(this.props.Totals.Range2)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR2))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card status-danger'>
                                <p className='metric-label'><AiOutlineWarning style={{marginRight:4}}/> +30 Days</p>

                                {this.props.Totals.TotalR3 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR3 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-danger'>{NumberFormat(this.props.Totals.Range3)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR3))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card status-primary'>
                                <p className='metric-label'>Total Overdue</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.TotalDueInv))}</div>
                            </div>
                        </div>
                    </div>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                            </div>
                            <div className='pb-3' />
                            <div className="tableFixHeadSmall ">
                                <table className='table table-clean'>
                                    <thead>
                                        <tr>
                                            <th>Invoice No</th>
                                            <th>Customer No</th>
                                            <th>Customer Name</th>
                                            <th>Due Date</th>
                                            <th><AiOutlineClockCircle style={{marginRight:4}}/>Days Dlq</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.data.map((order, o) => (
                                            <tr className={this.selectColor(Number(order.DaysDlq))} key={o}>
                                                <td>{order.InvoiceNo}</td>
                                                <td>{order.CustomerNo}</td>
                                                <td>{order.CustomerName}</td>
                                                <td className='text-center'>{DateFormatMAS90(order.InvoiceDueDate)}</td>
                                                <td className='text-center'>
                                                    <span className={`dash-days-badge ${this.selectColor(Number(order.DaysDlq))}`}>
                                                        {order.DaysDlq}d
                                                    </span>
                                                </td>
                                                <td className='text-center'>${NumberFormat(pricesFormat(order.Balance))}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
